
import React from "react";
import './App.css';

import V1 from './images/v2.mp4';
import Logo from './images/Logo.png';


function App() {
  return (
    <div className="App">
    <div className="vc1">
    <video src={V1} autoPlay loop muted playsInline className="v1" />
    </div>
    <div className="Branding">
    </div>
    <div className="LogoCC">
    <div className="detailsCC">

    <p className="firstTitle">Our website getting a new design, Please Contact us for further details.</p>
    <p className="secondTT">Head of Operations: Ph: +91 8838581923 | Email: vignesh@swathii.com</p>
    <p className="thirdTT">Admin: Ph: +91 9940915885 | swathimetalsasia@gmail.com</p>
    <div>
    
    <img src={Logo} className="logoCC"/>
    </div>
    </div>
    
    
    </div>
    
      

    </div>
  );
}

export default App;
